import Vue from 'vue'
import VueRouter from 'vue-router'
import LuckyBalls from '../views/LuckyBalls.vue'
import config from '../config/config';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'LuckyBalls',
    component: LuckyBalls
  }
]

const router = new VueRouter({
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {  
  if (!to.query.lang) {
    to.query.lang = config.defaultLanguage.short;
    next({ path: to.path, query: to.query });
  }
  else {
    next();
  }
});

export default router
